import { Button } from '@/components/ui/button'
import { LayoutDashboard, LayoutGrid } from 'lucide-react'
import { useEffect, useState } from 'react'

const STORAGE_KEY = 'xo-admin-density'
type Density = 'cozy' | 'compact'

function applyDensity(density: Density) {
  // Maps to a `data-density="..."` attribute on <html>; CSS in styles.css can
  // optionally adjust spacing tokens based on this. No-op if not styled yet.
  document.documentElement.dataset.density = density
}

export function DensityToggle() {
  const [density, setDensity] = useState<Density>(() => {
    if (typeof window === 'undefined') return 'cozy'
    return (localStorage.getItem(STORAGE_KEY) as Density) || 'cozy'
  })

  useEffect(() => {
    applyDensity(density)
    localStorage.setItem(STORAGE_KEY, density)
  }, [density])

  const next: Density = density === 'cozy' ? 'compact' : 'cozy'
  return (
    <Button
      size="icon"
      variant="ghost"
      onClick={() => setDensity(next)}
      title={`Switch to ${next} density`}
    >
      {density === 'cozy' ? (
        <LayoutDashboard className="size-4" />
      ) : (
        <LayoutGrid className="size-4" />
      )}
    </Button>
  )
}
